export var AUTH_RESULT;
(function (AUTH_RESULT) {
  AUTH_RESULT[AUTH_RESULT["FAILED"] = 0] = "FAILED";
  AUTH_RESULT[AUTH_RESULT["PASSED"] = 1] = "PASSED";
  AUTH_RESULT[AUTH_RESULT["UUID"] = 2] = "UUID";
  AUTH_RESULT[AUTH_RESULT["FAILED_DEVELOPMENT"] = 3] = "FAILED_DEVELOPMENT";
})(AUTH_RESULT || (AUTH_RESULT = {}));